define(function (require) {
    "use strict";

    var _ = require("underscore");

    var lpUtils = require('utils/lpUtils');
    var LE = require("app");

    var ApiResources = require("assets/data/apiResources.json");
    var Config = require("personalization-web-agent-config/config.json");

    var RevisionedModel = require("models/RevisionedModel");

    var KEYS = {
        NAME: "name",
        SPAN: "span",
        DESCRIPTION: "description",
        ENABLED: "enabled",
        MODE: "mode",
        URL: "url",
        FALLBACK_URL: "config.fallbackUrl",
        FALLBACK_URL_TIMEOUT: "config.fallbackUrlTimeout",
        TYPE: "type",
        ORDER: "order",
        PARAMETERS: "parameters",
        SKILLS: "skillIds"
    };

    var MODES = {
        PUBLISHED: "published",
        TEST: "test"
    };

    var TYPES = {
        IFRAME: "iFrame",
        CORE: "core"
    };

    var SPANS = {
        SINGLE: "1",
        DOUBLE: "2",
        TRIPLE: "3",
        QUADRUPLE: "4"
    };

    var WidgetModel = {};
    LE.module("LEPersonalization", function (LEPersonalization, LE, Backbone, Marionette, $, _) {
        WidgetModel = RevisionedModel.extend({
            resource: ApiResources.AccountConfig.Personalization.AgentWidgets,
            name: "WidgetModel",
            defaults: {
                name: "",
                span: "1",
                description: "",
                enabled: true,
                mode: MODES.TEST,
                url: "",
                type: TYPES.IFRAME,
                parameters: [],
                skillIds: []
            },

            initialize: function(options){

            },

            save : function(attributes, options){
                this.setValidations();
                return RevisionedModel.prototype.save.call(this, attributes, options);
            },

            setValidations: function() {
                this.validation =  _.extend({}, this.basicValidation);
                if(this.get(KEYS.TYPE) === TYPES.IFRAME) {
                    _.extend(this.validation, this.customValidation);
                }
            },

            getWidgetInitials: function(){
                return lpUtils.initialsFromString(this.get(KEYS.NAME));
            },

            togglePilotMode: function(pilot){
                if(pilot){
                    this.set(KEYS.MODE, MODES.TEST);
                }
                else{
                    this.set(KEYS.MODE, MODES.PUBLISHED);
                }
            },

            isPilotMode: function(){
                return this.get(KEYS.MODE) === MODES.TEST;
            },

            setEnabled: function(enabled){
                this.set(KEYS.ENABLED, enabled);
            },

            isEnabled: function(){
                return this.get(KEYS.ENABLED);
            },

            setName: function(name){
                this.set(KEYS.NAME, name);
            },

            getName: function(){
                return this.get(KEYS.NAME);
            },

            getType: function(){
                return this.get(KEYS.TYPE);
            },

            isCoreWidget: function(){
                return this.get(KEYS.TYPE) === TYPES.CORE;
            },

            getDescription: function(){
                return this.get(KEYS.DESCRIPTION);
            },

            setDescription: function(description){
                this.set(KEYS.DESCRIPTION, description);
            },

            getSize: function(){
                return this.get(KEYS.SPAN);
            },

            setSize: function(size){
                this.set(KEYS.SPAN, size);
            },

            getParameters: function(){
                return this.get(KEYS.PARAMETERS);
            },

            setParameters: function(parametersArray){
                this.set(KEYS.PARAMETERS, parametersArray);
            },

            getNumberOfParameters: function(){
                return this.get(KEYS.PARAMETERS).length;
            },

            getURL: function(){
                return this.get(KEYS.URL);
            },

            getOrder: function(){
                return this.get(KEYS.ORDER);
            },

            setURL: function(URL){
                this.set(KEYS.URL, URL);
            },

            getFallbackURL: function(){
                return this.get(KEYS.FALLBACK_URL);
            },

            setFallbackURL: function(FALLBACK_URL){
                this.set(KEYS.FALLBACK_URL, FALLBACK_URL);
            },

            getFallbackURLTimeout: function(){
                return this.get(KEYS.FALLBACK_URL_TIMEOUT);
            },

            setFallbackURLTimeout: function(FALLBACK_URL_TIMEOUT){
                this.set(KEYS.FALLBACK_URL_TIMEOUT, FALLBACK_URL_TIMEOUT);
            },

            isSaveAllowed: function(){
                return !_.isEmpty(this.get(KEYS.NAME)) && !_.isEmpty(this.get(KEYS.URL));
            },

            getSkills: function() {
                return this.get(KEYS.SKILLS);
            },

            setSkills: function(skills, options) {
                this.set(KEYS.SKILLS, skills, options);
            },

            setOrder: function(order){
                this.set(KEYS.ORDER, order);
            },

            addSkill: function(skill) {
                var skills = this.getSkills();
                if (!_.include(skills, skill)) {
                    skills.push(skill);
                    this.setSkills(skills);
                }
            },

            basicValidation: {
                "name": [
                    {
                        required:true,
                        minLength:1,
                        msg:"LEPersonalization.webAgent.widget.widgetEdit.errors.name.empty"
                    }
                ],
                "description": [
                    {
                        required: false,
                        minLength: 0,
                        maxLength: Config.iFrameWidget.widgetDescriptionMaxLength,
                        msg: "LEPersonalization.webAgent.widget.widgetEdit.errors.description.limit"
                    }
                ]
            },
            customValidation: {
                "url": [
                    {
                        required:true,
                        minLength:1,
                        msg:"LEPersonalization.webAgent.widget.widgetEdit.errors.url.empty"
                    },
                    {
                        pattern:"fullHttpsUrl",
                        msg:"LEPersonalization.webAgent.widget.widgetEdit.errors.url.not.valid"
                    }
                ],

                "config.fallbackUrl": [
                    {
                        required:false,
                        minLength:1,
                        msg:"LEPersonalization.webAgent.widget.widgetEdit.errors.url.empty"
                    },
                    {
                        pattern:"fullHttpsUrl",
                        msg:"LEPersonalization.webAgent.widget.widgetEdit.errors.url.not.valid"
                    }
                ]
            },
            TYPES: TYPES,
            MODES: MODES,
            toJSON: function (options) {
                var json = RevisionedModel.prototype.toJSON.apply(this, [].slice.apply(arguments));

                if (_.has(json, "isSupported")) {
                    delete json.isSupported;
                }

                if (_.has(json, "isNotConfigurable")) {
                    delete json.isNotConfigurable;
                }

                return json;
            }
        });
    });
    WidgetModel.SPANS = SPANS;
    WidgetModel.KEYS = KEYS;
    WidgetModel.TYPES = TYPES;
    WidgetModel.MODES = MODES;
    return WidgetModel;
});
